export default {"src":"/evde-internet/_next/static/media/green-leaf.08192f9f.svg","height":18,"width":18};